import React, { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { FC, useRef } from 'react'
import axios from 'axios';

interface Coupon {
    id: string;
    couponName: string;
    couponIcon: string;
    couponValue: string;
    status: string;
    issuedTo: string[];
    couponDesc: string;
    redeemCode: string;
}

interface User {
    id: string;
    name: string;
    productionIds: number[];
    registryId: string
}

interface ProductionReceiptProps {
    user: any;
    deletePickupPoints: boolean;
    setDeletePickupPoints: (value: boolean) => void;
}

const MtHubs: React.FC<ProductionReceiptProps> = ({ user, deletePickupPoints, setDeletePickupPoints }) => {
    const [selectedPickupPoint, setSelectedPickupPoint] = useState<any[]>([]);

    const handleSelect = (id: string | number) => {
        setSelectedPickupPoint((prev: any) => {
            if (prev.includes(id)) {
                return prev.filter((item: any) => item !== id);
            } else {
                return [...prev, id];
            }
        });
    };

    useEffect(() => {
        const deletePoints = async () => {
            if (deletePickupPoints && selectedPickupPoint.length > 0) {
                try {
                    const authData = localStorage.getItem('kt-auth-react-v');
                    if (!authData) return;
                    const parsedData = JSON.parse(authData);
                    const token = parsedData.data?.token;

                    const remainingPickupPoints = user.pickupPointInfo
                        .filter((point: any) => !selectedPickupPoint.includes(point.pickupPointId))
                        .map((point: any) => point.pickupPointId);

                    const payload = {
                        sponsorId: user.sponsorId,
                        sponsorName: user.sponsorName,
                        startDate: user.startDate,
                        endDate: user.endDate,
                        packageId: user.packageId,
                        pickupPoint: remainingPickupPoints
                    };

                    const response = await axios.put(`${process.env.REACT_APP_BASE_API_URL}sponsorCommitments/${user.id}`, payload, {
                        headers: {
                            'Authorization': `Bearer ${token}`,
                            'Content-Type': 'application/json'
                        }
                    });

                    if (response.status === 200 || response.status === 204) {
                        setDeletePickupPoints(false);
                        window.location.reload();
                    } else {
                        console.error('Failed to delete pickup points', response);
                    }
                } catch (error) {
                    console.error('Error deleting pickup points:', error);
                }
            } else if (deletePickupPoints) {
                setDeletePickupPoints(false);
            }
        };

        deletePoints();

    }, [deletePickupPoints, user, selectedPickupPoint, setDeletePickupPoints]);
    return (
        <>
            <div style={{ flex: 1, padding: '24px' }}>
                {user?.pickupPointInfo?.map((pickupPoint: any) => {
                    const poeDoc = pickupPoint.profile?.find((doc: any) => doc.docType === 'POE')?.docUrl;
                    const poiDoc = pickupPoint.profile?.find((doc: any) => doc.docType === 'POI')?.docUrl;
                    const pofDoc = pickupPoint.profile?.find((doc: any) => doc.docType === 'POF')?.docUrl;

                    return (
                        <div
                            key={pickupPoint.pickupPointId}
                            style={{
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'space-between',
                                marginBottom: '24px',
                                paddingBottom: '24px',
                                borderBottom: '2px solid #e8e8e8'
                            }}
                        >
                            <div className='d-flex align-items-center'>
                                <div className='form-check form-check-custom form-check-solid me-5'>
                                    <input
                                        className='form-check-input'
                                        type='checkbox'
                                        checked={selectedPickupPoint.includes(pickupPoint.pickupPointId)}
                                        onChange={() => handleSelect(pickupPoint.pickupPointId)}
                                    />
                                </div>
                                <div>
                                    <p className='text-dark text-hover-primary fw-bold fs-3 mb-0'>
                                        {pickupPoint.pickupPointName}
                                    </p>
                                    <p style={{ margin: '4px 0 0 0', fontSize: '11px', fontWeight: '600', color: '#666' }}>
                                        Address: {pickupPoint.address.street}
                                    </p>
                                </div>
                            </div>

                            <div style={{ display: 'flex', gap: '12px' }}>
                                {poeDoc && (
                                    <div style={{
                                        width: '60px',
                                        height: '60px',
                                        borderRadius: '50%',
                                        backgroundColor: '#f8f8f8',
                                        overflow: 'hidden',
                                        flexShrink: 0,
                                        border: '3px solid #e0e0e0',
                                        boxShadow: '0 4px 12px rgba(0,0,0,0.08)'
                                    }}>
                                        <img
                                            src={poeDoc}
                                            alt="POE"
                                            style={{ width: '100%', height: '100%', objectFit: 'cover' }}
                                        />
                                    </div>
                                )}

                                {poiDoc && (
                                    <div style={{
                                        width: '60px',
                                        height: '60px',
                                        borderRadius: '50%',
                                        backgroundColor: '#f8f8f8',
                                        overflow: 'hidden',
                                        flexShrink: 0,
                                        border: '3px solid #e0e0e0',
                                        boxShadow: '0 4px 12px rgba(0,0,0,0.08)'
                                    }}>
                                        <img
                                            src={poiDoc}
                                            alt="POI"
                                            style={{ width: '100%', height: '100%', objectFit: 'cover' }}
                                        />
                                    </div>
                                )}

                                {pofDoc && (
                                    <div style={{
                                        width: '60px',
                                        height: '60px',
                                        borderRadius: '50%',
                                        backgroundColor: '#f8f8f8',
                                        overflow: 'hidden',
                                        flexShrink: 0,
                                        border: '3px solid #e0e0e0',
                                        boxShadow: '0 4px 12px rgba(0,0,0,0.08)'
                                    }}>
                                        <img
                                            src={pofDoc}
                                            alt="POF"
                                            style={{ width: '100%', height: '100%', objectFit: 'cover' }}
                                        />
                                    </div>
                                )}
                            </div>
                        </div>
                    );
                })}
            </div>
        </>
    );
};

export default MtHubs;